import { Component } from '@angular/core';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';

@Component({
    selector: 'jira-connector-panel',
    templateUrl: './jira.connector.panel.html'
})
export class JIRAConnectorPanel extends ACDATAConnectorPanel {
    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@JIRA',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.JIRAInfo',
            ControlType: JIRAConnectorPanel,
            Default: null
        };
    }
}
